define({
  clickSignUp: '点击「加入班级」自动打开ClassIn加入</br>或者手动打开ClassIn搜索班级ID加入',
  copyPubcourseId: '点击复制班级ID',
  pressPubcourseId: '长按复制班级ID',
  courseId: '班级ID：',
  institution: '学校简介',
  cellphoneNumber: '请输入手机号码',
  verificationCode: '图片验证码',
  smsVerification: '短信验证码',
  enter6To20Pwd: '请输入6-20位密码',
  readUserAgm:
    '我已阅读并同意<a class="is-link" href="//www.eeo.cn/s/agreement/?type=user&lang=zh-CN" target="_blank">《ClassIn用户协议》</a>',
  downTip: '加入班级后请尽快下载ClassIn并使用该手机号和密码登录进入班级',
  apply: '立即加入',
  applyNow: '加入班级',
  applied: '已加入',
  success: '加入成功',
  end: '报名已结束',
  full: '该班级学生人数已达上限',
  down: '下载 ClassIn',
  applyPubcourse: '加入班级',
  teacher: '班主任：{name}',
  teachers: '教师：',
  duration: '时长：',
  minute: '钟',
  downLoadTip: '尚未下载ClassIn？<span style="color: #009265;">立即下载</span>',
  share: {
    title: '【加入班级】{courseName} | {schoolName}',
    des: '班级：{courseName} | 教师：{teacherName}',
    desCourse: '班级：{courseName}',
    title2: '【加入班级】{courseName} | {schoolName}',
  },
  subtitle: {
    downAndinstall: '请下载安装ClassIn，<span style="color:#f66656;font-weight: bold;">使用该账号和密码登录</span>准备上课吧~',
    downAndReady: '请下载安装ClassIn，为下一次加入班级做好准备。',
  },
  placeholder: {
    phoneNumber: '手机号/邮箱',
    nickName: '请输入您的姓名',
    verCode: '验证码',
    msmCode: '短信验证码',
    password: '请输入6-20位ClassIn登录密码',
  },
  form: {
    sendMsg: '获取',
    reSend: '重发{num}S',
  },
  downloadImg: {
    scanCode: '扫描二维码，加入班级',
    save: '长按保存图片',
  },
  tip: {
    deleted: '此公开课已删除，请联系客服人员',
    institutionDisabled: '此学校已停用，请联系客服人员',
    noAddStu: '学校账号不能添加为学生',
    master: '您已是该班级的班主任',
    auditor: '您已是该班级的旁听生',
    copySuccess: '复制成功',
    copyFail: '复制失败',
    browserIos: '请在Safari下访问本页面',
    browserWin: '微信暂不支持直接打开该链接，请复制后在浏览器打开',
    invalid: '加入班级链接已经失效，请联系您上课的学校获取有效的链接',
    disband: '班级解散了</br>该班级不能加入了哦',
    closeOpen: '班级设置了权限</br>联系班级管理员开放加入吧',
    more: '等',
    beAlreadyFullAdmin: '课程使用人数已满，请联系管理员扩容',
  },
  errorMsg: {
    enterPhoneNumber: '请输入手机号码',
    enterTruePhoneNumber: '请输入正确的手机号',
    // NEW:
    email_tips: '请输入邮箱',
    email_Error: '请输入正确的邮箱',
    enterName: '请输入姓名',
    enterNameRule: '请输入2-24个字的姓名',
    enterVerCode: '请输入验证码',
    enter6To20Pwd: '请输入正确6-20位密码',
    pwdHasNumEn: '密码必须包含字母和数字',
    pwdIllegal: '密码不能包含非法字符',
    pwdHasCn: '密码不能包含中文字符',
    pwdHasEmpty: '密码不能包含空格',
    apiOverrun: '请求次数超限',
    wrongVerCode: '验证码输入错误',
    operateFail: '操作失败',
    phoneIllegal: '手机号码不合法',
    sendLimit: '验证码发送次数已达上限',
    sendfrequently: '验证码发送过于频繁',
    sendFail: '验证码发送失败',
    firstError: '首位不允许为0',
    100: '参数不全或错误',
    101: '未登录',
    102: '无权限',
    108: '今日验证码发送次数达上限 ',
    109: '验证码发送太过频繁',
    110: '验证码发送失败，请稍后重试',
    113: '手机号没有注册',
    133: '请输入正确的邮箱',
    134: '请输入正确的手机号',
    135: '手机号已注册，请登录',
    136: '邮箱已注册，请登录',
    166: '课节下已存在此学生',
    20704: '同一手机最多关联5个ClassIn账号，请使用其他手机号尝试。',
    20718: '请输入正确的邮箱',
    20727: '操作频繁',
    20728: '验证码错误',
    20729: '验证码错误',
    20730: '请求过于频繁，请稍后重试',
    20731: '验证码发送太过频繁',
    20732: '今日验证码发送次数达上限',
    20733: '参数错误，请重新尝试',
    20734: '验证码发送失败，请稍后重试',
  },
  jumpPage: {
    starting: 'ClassIn 启动中…',
    openClassIn: '请点击弹框「<span style="color:#000;font-weight:bold;">打开ClassIn</span>」按钮加入',
    browserDontTip: '浏览器无弹框提示？请',
    clickThis: '点击此处',
    searchPubcourseId: '重试或手动打开ClassIn搜索班级ID: {pubcourseId}',
    dontInstallClassIn: '未安装  ClassIn',
    by: '请通过',
    signUpByPhone: '手机号/邮箱报名',
    classInPubcourse: 'ClassIn班级',
  },
  
})
